import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab, Container, Paper, Grid, Typography, FormControl, InputLabel, Select, MenuItem, Card, CardContent } from '@mui/material';
import AmortizationSchedule from '../components/AmortizationSchedule';
import BalloonPayment from '../components/BalloonPayment';
import EarlyRepayment from '../components/EarlyRepayment'
import VariableRate from '../components/VariableRate'
import VariableRent from '../components/VariableRent'
import '../styles/LoanAmortization.scss';
import '../styles/loanCommon.scss';
import { LeasesBasicDetails } from '../../../elements';
import AssetsNav from '../../../elements/AssetsNav';
import AssetsMenueList from "../../../elements/AssetsMenuList";
import LeaseDowntime from '../components/LeaseDowntime';
import { trackActivity } from '../../../../utils/mixpanel';

const LoanAmortization = () => {
    const [loanType, setLoanType] = useState('fixed');

    const handleLoanTypeChange = (event) => {
        setLoanType(event.target.value);
    };

    useEffect(() => {
        trackActivity('Page Viewed', { page_title: 'Loan Amortization' })
    }, [])
    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin'>
                <AssetsNav />
                <div className='lease-details-content'>
                    <Paper square className='responsive-paper'>
                        <Grid container spacing={1} className='responsive-grid' alignItems='flex-end'>
                            <Grid item md={4} xs={12} className='menu-container lease-list-link-mt'>
                                <AssetsMenueList pageLabel={`Loan Amortization`} />
                            </Grid>
                            <Grid item md={8} xs={12}> </Grid>
                        </Grid>
                    </Paper>
                    <div>
                        <Container maxWidth="xl" className="loan-amortization-container" style={{ padding: "15px" }}>
                            {/* Loan Type Selector at the Top */}
                            <Card className="loan-type-selector-card">
                                <CardContent className="loan-type-card-content">
                                    <Box className="loan-type-selector-wrapper">
                                        <Typography className="loan-heading">
                                            Loan Type:
                                        </Typography>
                                        <FormControl
                                            size="small"
                                            variant="outlined"
                                            className="loan-type-form-control"
                                        >
                                            <InputLabel id="global-loan-type-label">Select Loan Type</InputLabel>
                                            <Select
                                                labelId="global-loan-type-label"
                                                id="global-loan-type-select"
                                                value={loanType}
                                                label="Select Loan Type"
                                                onChange={handleLoanTypeChange}
                                                className="loan-type-select"
                                            >
                                                <MenuItem value="fixed">Fixed Loan</MenuItem>
                                                <MenuItem value="early-repayment">Early Repayment</MenuItem>
                                                <MenuItem value="balloon">Balloon Payment</MenuItem>
                                                <MenuItem value="variable-rate">Variable Rate</MenuItem>
                                                <MenuItem value="variable-rent">Variable Rent</MenuItem>
                                                <MenuItem value="lease-downtime">Lease Downtime</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </CardContent>
                            </Card>
                            {/* Conditional Content Based on Loan Type */}
                            <Box className="loan-amortization-content">
                                {loanType === 'fixed' && (
                                    <AmortizationSchedule
                                        loanType={loanType}
                                        onLoanTypeChange={handleLoanTypeChange}
                                    />
                                )}
                                {loanType === 'early-repayment' && (
                                    <EarlyRepayment
                                        loanType={loanType}
                                        onLoanTypeChange={handleLoanTypeChange}
                                    />
                                )}
                                {loanType === 'balloon' && (
                                    <BalloonPayment
                                        loanType={loanType}
                                        onLoanTypeChange={handleLoanTypeChange}
                                    />
                                )}
                                {loanType === 'variable-rate' && (
                                    <VariableRate
                                        loanType={loanType}
                                        onLoanTypeChange={handleLoanTypeChange}
                                    />
                                )}
                                {loanType === 'variable-rent' && (
                                    <VariableRent
                                        loanType={loanType}
                                        onLoanTypeChange={handleLoanTypeChange}
                                    />
                                )}
                                {loanType === 'lease-downtime' && (
                                    <LeaseDowntime
                                        loanType={loanType}
                                        onLoanTypeChange={handleLoanTypeChange}
                                    />
                                )}
                            </Box>
                        </Container>
                    </div>
                </div>
            </Paper>
        </>
    );
};

export default LoanAmortization;

